export class MenuAttachmentModel {
  id: number;
  table_name: string;
  type: string;
  table_record_id: number;
  attachment_url: string;
  priority: number;
  name: string;
  description: string;

  constructor(id = 0,
              table_name = '',
              type = '',
              table_record_id = 0,
              attachment_url = '',
              priority = 0,
              name = '',
              description = '') {
    this.id = id;
    this.table_name = table_name;
    this.type = type;
    this.table_record_id = table_record_id;
    this.attachment_url = attachment_url;
    this.priority = priority;
    this.name = name;
    this.description = description;
  }
}
